export enum GregorioSignOrientation {
  SO_OVER,
  SO_UNDER,
}

export enum GregorioHepisemaVbasepos {
  HVB_AUTO = 0,
  HVB_MIDDLE = 1,
  HVB_O_LOW = 2,
  HVB_O_HIGH = 3,
  HVB_U_LOW = 4,
  HVB_U_HIGH = 5
}

export interface GregorioHepisemaAdjustment {
  vbasepos: GregorioHepisemaVbasepos;
  nudge: string | null;
  pitch_extremum: number | null;
}

export enum GrehepisemaSize {
  H_NORMAL,
  H_SMALL_LEFT,
  H_SMALL_CENTRE,
  H_SMALL_RIGHT,
}

export enum GtexType {
  T_ONE_NOTE = 1,
  T_PES,
  T_PES_QUADRATUM,
  T_QUILISMA_PES,
  T_PES_QUASSUS,
  T_QUILISMA_PES_QUADRATUM,
  T_FLEXUS,
  T_FLEXUS_ORISCUS,
  T_FLEXUS_ORISCUS_SCAPUS,
  T_PES_ORISCUS,
  T_PORRECTUS,
  T_TORCULUS,
  T_TORCULUS_QUILISMA,
  T_SCANDICUS,
  T_ANCUS,
  T_SALICUS,
  T_SALICUS_FLEXUS,
  T_PORRECTUS_FLEXUS,
  T_TORCULUS_RESUPINUS,
  T_TORCULUS_LIQUESCENS,
  T_TORCULUS_RESUPINUS_FLEXUS
}
